import { TranslateModule } from '@ngx-translate/core';
import {
  Customer,
  Locale,
  Maybe,
  Role,
  Site,
  SiteState,
} from '@iss/libs/graphql';
import { FormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import { Component, Inject, Input, Self } from '@angular/core';
import { NgIf } from '@angular/common';

import { SiteInputComponent } from '../site-input';

import {
  LabelDirective,
  FormFieldComponent,
  FormFieldErrorDirective,
  Control,
  NOOP_VALUE_ACCESSOR,
} from '@iss/core/forms';

@Component({
  selector: 'wo-site-field',
  templateUrl: './site-field.component.html',
  standalone: true,
  imports: [
    FormFieldComponent,
    FormFieldErrorDirective,
    LabelDirective,
    NgIf,
    ReactiveFormsModule,
    SiteInputComponent,
    TranslateModule,
  ],
})
export class SiteFieldComponent {
  public customerIds: Maybe<readonly Customer['id'][]>;

  @Input() public readonly: Maybe<boolean>;
  @Input() public loading: Maybe<boolean>;
  @Input() public forceTypeahead: Maybe<boolean>;
  @Input() public withAll: Maybe<boolean>;
  @Input() public set customerId (customerId: Maybe<Customer['id'] | readonly Customer['id'][] | 'ALL'>) {
    this.customerIds = Array.isArray(customerId)
      ? customerId
      : customerId === 'ALL' || !customerId
        ? undefined
        : [ customerId ];
  }
  @Input() public available: Maybe<readonly Site['id'][]>;
  @Input() public role: Maybe<Role>;
  @Input() public country: Maybe<Locale>;
  @Input() public placeholder: Maybe<string>;
  @Input() public siteStates: Maybe<readonly SiteState[]>;
  @Input() public multi: Maybe<boolean>;
  @Input() public showNecessity = true;
  @Input() public clearable = true;

  public constructor(
    @Self() @Inject(NgControl) public readonly control: Control<FormControl>,
  ) {
    this.control.valueAccessor = NOOP_VALUE_ACCESSOR;
  }
}
